import { maxLength, phone } from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";

import { UserCommunicationsFormValues } from "./UserCommunicationsForm.types.ts";

export class UserCommunicationsFormValidator extends Validator<UserCommunicationsFormValues> {
  constructor() {
    super();

    this.forField("workPhone", [maxLength(50), phone]);
  }
}
